import { formatUOSNumber } from './panelNumbers';

export const duplicateSSRsByUOS = (switches) => {
  const countsByUOS = new Map();

  (switches ?? []).forEach((eachSwitch) => {
    const UOS = formatUOSNumber(eachSwitch?.UOS);
    if (!UOS) return;

    if (!countsByUOS.has(UOS)) countsByUOS.set(UOS, new Map());
    const counts = countsByUOS.get(UOS);

    const ssrKeys = new Set(
      (Array.isArray(eachSwitch?.selectedSSR) ? eachSwitch.selectedSSR : [])
        .flatMap((entry) => Object.keys(entry ?? {})),
    );

    ssrKeys.forEach((key) => counts.set(key, (counts.get(key) ?? 0) + 1));
  });

  return [...countsByUOS.entries()]
    .map(([UOS, counts]) => ({
      UOS,
      ssrs: [...counts.entries()]
        .filter(([, count]) => count > 1)
        .map(([key]) => key),
    }))
    .filter(({ ssrs }) => ssrs.length > 0);
};
